export type TSrc = {
  lang: string;
  text: string;
};

export type TDst = {
  audio?: string;
  lang: string;
  text: string;
};

// A candidate translation for a segment. Mirrors the backend SegmentTranslationVariant /
// ml_api MLApiSegmentTranslationVariant contract.
export type TTranslationVariant = {
  id?: string;
  predicted_duration?: number;
  recommended?: boolean;
  speed_ratio?: number;
  text: string;
};

export const SegmentStatus = {
  Done: 'done',
  Error: 'error',
  Processing: 'processing',
  Updated: 'updated',
} as const;

export type TSegmentStatus = (typeof SegmentStatus)[keyof typeof SegmentStatus];

export const SegmentProcessingStep = {
  Translating: 'translating',
  Voicing: 'voicing',
} as const;

export type TSegmentProcessingStep = (typeof SegmentProcessingStep)[keyof typeof SegmentProcessingStep];

export type TServerSegment = {
  id: string;
  dst: TDst;
  end: string;
  processing_started_at?: string;
  processing_step?: TSegmentProcessingStep;
  selected_translation_variant?: TTranslationVariant;
  speaker: string;
  src: TSrc;
  start: string;
  status: TSegmentStatus;
  translation_variants?: TTranslationVariant[];
};

export type TExtendedSegment = {
  isEditingSrc?: boolean;
  isMerging?: boolean;
  isRewriting?: boolean;
  isSavingError?: boolean;
  isVoiceCloneError?: boolean;
  overlappedTimestamps?: (TServerSegment['end'] | TServerSegment['start'])[];
  rewritingResult?: string;
} & TServerSegment;

export type TAutoSavingSegmentData = {
  dst?: TExtendedSegment['dst'];
  end?: TExtendedSegment['end'];
  selected_translation_variant?: TExtendedSegment['selected_translation_variant'];
  speaker?: TExtendedSegment['speaker'];
  start?: TExtendedSegment['start'];
};

export type TUpdatingSegmentData = ({ speaker: TExtendedSegment['speaker']; src: TExtendedSegment['src'] } | TAutoSavingSegmentData) &
  Pick<TExtendedSegment, 'id'>;

export type ParsedSrt = {
  id: string;
  endSeconds: number;
  endTime: string;
  speakerId: null | string;
  startSeconds: number;
  startTime: string;
  text: string;
};

export const SegmentLocation = {
  Bottom: 'bottom',
  Top: 'top',
} as const;

export const MergeSegmentMode = {
  Merge: 'merge',
  MergeAndRetranslate: 'merge-and-retranslate',
} as const;

export type TMergeSegmentMode = (typeof MergeSegmentMode)[keyof typeof MergeSegmentMode];

export type TSplittingSegmentData = {
  dst?: TServerSegment['dst'];
  src?: TServerSegment['src'];
} & Pick<TServerSegment, 'end' | 'start'>;
export type TSegmentLocation = (typeof SegmentLocation)[keyof typeof SegmentLocation];
